module.exports = __webpack_public_path__ + "img/icon-24-ic-wifi.9e75b624.svg";